<template>
  <tr>
    <td class="pa-0 pl-1">
      <v-checkbox
        v-model="selected"
        :value="unit.unitID"
        multiple
        dense
        hide-details
        @change="$emit('update:checked', selected)"
        class="ma-0 pa-0"/>
    </td>
    <td><v-icon v-if="unit.unit_is_pack" color="cyan" small>mdi-package-variant-closed</v-icon> {{ unit.unitName }} <span class="caption text--secondary pl-1">{{ unit.unitInfo }}</span></td>
    <td align="right" class="font-weight-light">{{ placement(unit.unitPlacement) }}</td>
    <td align="right">
      <span v-if="!edit.price" @click="editPriceAction">{{ unit.unitPlanPrice*1 }}</span>
      <input
        v-if="edit.price"
        v-model="price"
        ref="priceInput"
        @blur="savePriceAction"
        @keydown.enter="$event.target.blur()"
        @keydown.esc="cancelPriceAction"
        class="yellow lighten-3 px-1 editing" style="width: 55px">
    </td>
    <td align="center" v-for="month in months" :key="month" :class="{ 'white--text': true, caption: true, green: list[month] }" style="border-left: 1px solid #ddd !important; border-bottom: 1px solid #ddd !important" @click="editSkedAction">
      {{ isNaN(list[month]) || list[month] == 1 ? '' : list[month].toFixed(2)*1 }}
    </td>
    <td v-if="!months" colspan="12" class="pa-0">
      <input
        v-model="sked"
        ref="skedInput"
        @blur="saveSkedAction"
        @keydown.enter="$event.target.blur()"
        @keydown.esc="cancelSkedAction"
        class="yellow lighten-3 px-1 editing">
    </td>
    <td align="right">{{ total }}</td>
  </tr>
</template>

<script>
import api from '@/api'

function parseSked (sked) {
  if ( sked == '' ) return { list: {}, total: 0 }

  let ma, total = 0, list = {},
      src = sked.split(','),
      error = (i) => ({ list: {}, total: 0, error: (src[i] = '<span class="error">' + src[i] + '</span>', src.join(',')) })

  for ( let i = 0; i < src.length; i++ )
  {
    if ( null === (ma = src[i].match(/^(\d\d?)(?:-(\d\d?))?(?::(:)?(\d+))?$/)) ) return error(i)
    let a = +ma[1], b = +ma[2], q = typeof ma[4] === 'undefined' ? 1 : +ma[4]
    if ( a < 1 || a > 12 || list[a] )
      return error(i)
    if ( typeof ma[2] === 'undefined' )
      total += q, list[a] = q
    else if ( b < 1 || b > 12 || a > b || list[b] )
      return error(i)
    else if ( a == b )
      total += q, list[a] = q
    else {
      let range = b-a+1
      if ( typeof ma[3] === 'undefined' ) total += range*q
      else { total += q; q /= range }
      for ( ; a <= b; a++ )
        if ( list[a] ) error(i)
        else list[a] = q
    }
  }
  return { list: list, total: total }
}

const pText = {
  d: ['день', 'дня', 'дней'],
  m: ['месяц', 'месяца', 'месяцев'],
  a: ['адресат', 'адресата', 'адресатов'],
  p: ['выход', 'выхода', 'выходов']
}

export default {
  props: [ 'value', 'unit', 'selected', 'editing' ],
  data: () => ({
    edit: { price: false },
    months: [1,2,3,4,5,6,7,8,9,10,11,12],
    price: 0,
    sked: '',
    list: {},
    qnt: 0,
    total: 0,
    measure: 0,
    duration: 0,
    spotsTypes: {
      'banner': {icon: 'mdi-picture-in-picture-top-right', color: 'orange'},
      'shop': {icon: 'mdi-basket-outline', color: 'green'},
      'mailing': {icon: 'mdi-email-send-outline', color: '#af00af'},
      'landing': {icon: 'mdi-cards-variant', color: 'cyan'},
      'social': {icon: 'mdi-account-group-outline', color: 'blue'}
    },
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let sked = parseSked(this.unit.unitPlanSked)
      this.list = sked.list
      this.qnt = sked.total
      this.measure = this.unit.unitPlacement.substring(0, 1)
      this.duration = this.unit.unitPlacement.substring(1)
      this.total = (this.measure === 'm' ? Math.ceil(this.qnt/this.duration) : this.qnt)*this.unit.unitPlanPrice
      this.$emit('update:total', this.total)
    },
    placement (data) {
      let m = data.substring(0, 1), d = data.substring(1)
      if ( isNaN(d) || typeof pText[m] === 'undefined' ) return data
      if ( d > 4 && d < 21 ) return d + ' ' + pText[m][2]
      let x = d % 10
      return d + ' ' + (x == 1 ? pText[m][0] : ( x > 4 ? pText[m][2] : pText[m][1]))
    },
    editSkedAction () {
      this.$nextTick(() => {
        if ( this.editing ) return
        this.sked = this.unit.unitPlanSked
        this.months = false
        this.$nextTick(() => this.$refs.skedInput.focus())
        this.$emit('update:editing', this.unit.unitID)
      })
    },
    cancelSkedAction () {
      this.$emit('update:editing', false)
      this.months = [1,2,3,4,5,6,7,8,9,10,11,12]
    },
    saveSkedAction () {
      let sked = parseSked(this.sked)
      if ( sked.error )
      {
        this.$refs.skedInput.focus()
        this.$root.$alert(sked.error, true)
        return
      }
      if ( this.unit.unitPlanSked == this.sked )
        return this.cancelSkedAction()
      api.post('units/update/'+this.unit.unitID, { unitPlanSked: this.sked }).then(response => {
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.cancelSkedAction()
        this.list = sked.list
        this.qnt = sked.total
        this.total = (this.measure === 'm' ? Math.ceil(this.qnt/this.duration) : this.qnt)*this.unit.unitPlanPrice
        this.$emit('update:sked', this.sked)
        this.$emit('update:total', this.total)
      }).catch(error => {
        return this.$root.$alert(error, true)
      });
    },
    editPriceAction () {
      this.$nextTick(() => {
        if ( this.editing ) return
        this.price = this.unit.unitPlanPrice*1
        this.edit.price = true
        this.$nextTick(() => this.$refs.priceInput.focus())
        this.$emit('update:editing', this.unit.unitID)
      })
    },
    cancelPriceAction () {
      this.$emit('update:editing', false)
      this.edit.price = false
    },
    savePriceAction () {
      if ( isNaN(this.price) )
      {
        this.$refs.priceInput.focus()
        return
      }
      if ( this.price == this.unit.unitPlanPrice*1 )
        return this.cancelPriceAction()
      api.post('units/update/'+this.unit.unitID, { unitPlanPrice: this.price }).then(response => {
        this.cancelPriceAction()
        this.total = (this.measure === 'm' ? Math.ceil(this.qnt/this.duration) : this.qnt)*this.price
        this.$emit('update:price', this.price)
        this.$emit('update:total', this.total)
      }).catch(error => {
        return this.$root.$alert(error, true)
      });
    },
  }
}
</script>

<style scoped>
.editable { cursor: pointer; }
.editable:hover { color: #08A2B8 !important; border-bottom: 1px #08A2B8 dashed; }

input.editing {
  width: 100%;
  height: 100%;
  border: 1px inset #ccc !important
}
table td + td { border-left: 1px solid #ddd; }
</style>
